import { addToCollection, deepGet } from '../shared/helper.js'

export default {
  namespaced: true,
  state: {
    monthlyCollection: [],
    dailyCollection: [],
    currentDate: null,
    currentCustomer: -1,
    currentAccount: -1,
  },
  getters: {
    getMonthlyCollection: state => state.monthlyCollection,
    getDailyCollection: state => state.dailyCollection,
    getCurrentCustomer: state => state.currentCustomer,
    getCurrentAccount: state => state.currentAccount,
  },
  actions: {
    getDailyStatistics({ commit, state }, payload) {
      let search = []

      if (state.currentAccount > 0) {
        search.push({
          'accountId': state.currentAccount
        })
      }
      else if (state.currentCustomer > 0) {
        search.push({
          'customerId': state.currentCustomer
        })
      }

      const searchString = JSON.stringify(search)
      payload = {
        ...payload,
        search: searchString
      }

      // this requires a date, but the table isn't designed to send a date with
      return this.dispatch('get', {
        path: 'v1/statistics/daily/' + state.currentDate,
        ...payload,
        limit: 31 // Limit to 31 days for daily statistics
      }).then((res) => {
        const data = deepGet(res, 'body.data')
        if (data) {
          data.forEach(statistic => {
            statistic.id = statistic.date
            commit('addStatisticToCollection', { statisticsData: statistic, opts: { collection: 'dailyCollection' } })
          })
        }
        return res
      })
    },
    getMonthlyStatistics({ commit, state }, payload) {
      let search = []

      if (state.currentAccount > 0) {
        search.push({
          'accountId': state.currentAccount
        })
      }
      else if (state.currentCustomer > 0) {
        search.push({
          'customerId': state.currentCustomer
        })
      }

      const searchString = JSON.stringify(search)
      payload = {
        ...payload,
        search: searchString
      }

      return this.dispatch('get', {
        path: 'v1/statistics/monthly',
        ...payload
      }).then((res) => {
        const data = deepGet(res, 'body.data')
        if (data) {
          data.forEach(statistic => {
            statistic.id = statistic.month
            commit('addStatisticToCollection', { statisticsData: statistic, opts: { collection: 'monthlyCollection' } })
          })
        }
        return res
      }).catch(err => {
        console.error('Error fetching monthly statistics:', err)
        throw err
      })
    },
  },
  mutations: {
    addStatisticToCollection(state, { statisticsData, opts }) {
      const collection = opts && opts.collection ? state[opts.collection] : state.collection
      addToCollection(this, collection, statisticsData, null, opts)
    },
    setCurrentDate(state, date) {
      state.currentDate = date
    },
    clearMonthlyCollection(state) {
      state.monthlyCollection = []
    },
    clearDailyCollection(state) {
      state.dailyCollection = []
    },
    setCurrentCustomer(state, value) {
      state.currentCustomer = value
    },
    setCurrentAccount(state, value) {
      state.currentAccount = value
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/statistics/store.js